import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "space-y-8" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "card-global flex divide-x" }
const _hoisted_4 = { class: "flex-1 flex-col space-y-6" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = {
  for: "document-template-comment",
  class: "input-form-label"
}
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "flex space-x-12" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "input-form-label" }
const _hoisted_13 = { class: "input-form-label" }
const _hoisted_14 = { class: "rounded-lg border border-gray-200 p-4" }
const _hoisted_15 = { class: "flex items-center gap-3" }
const _hoisted_16 = { class: "input-form-label mb-0" }
const _hoisted_17 = {
  key: 0,
  class: "mt-4 space-y-4"
}
const _hoisted_18 = { class: "flex flex-wrap gap-6" }
const _hoisted_19 = { class: "flex items-center gap-2" }
const _hoisted_20 = { class: "flex items-center gap-2" }
const _hoisted_21 = { class: "max-w-xs" }
const _hoisted_22 = {
  for: "document-template-footer-height",
  class: "input-form-label"
}
const _hoisted_23 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_24 = { class: "input-form-label" }
const _hoisted_25 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_26 = { class: "border-t border-gray-200 pt-6" }
const _hoisted_27 = { class: "flex items-center justify-between gap-4" }
const _hoisted_28 = { class: "block-title" }
const _hoisted_29 = { class: "text-sm text-gray-500" }
const _hoisted_30 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2" }
const _hoisted_31 = { class: "input-form-label" }
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = { class: "input-form-label" }
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = { class: "input-form-label" }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "flex items-center gap-2 pt-7" }
const _hoisted_39 = ["id", "onUpdate:modelValue"]
const _hoisted_40 = ["for"]
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "input-form-label" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "input-form-label" }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = {
  key: 2,
  class: "md:col-span-2"
}
const _hoisted_48 = { class: "mb-2 flex items-center justify-between gap-4" }
const _hoisted_49 = { class: "input-form-label mb-0" }
const _hoisted_50 = { class: "space-y-2" }
const _hoisted_51 = { class: "input-form-label" }
const _hoisted_52 = ["onUpdate:modelValue"]
const _hoisted_53 = { class: "input-form-label" }
const _hoisted_54 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_55 = { class: "mt-2 text-sm text-gray-500" }
const _hoisted_56 = { class: "mt-4" }

import BackButton from "@/components/common/BackButton.vue";
import { ref, onMounted, reactive, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Button, SegmentedButtons } from "@/components/common/";
import DocumentTemplate from "@/types/documents/documentTemplate/DocumentTemplate";
import DocumentTemplateDataService from "@/services/documents/documentTemplate/DocumentTemplateDataService";
import Editor from "@tinymce/tinymce-vue";
import useVuelidate from "@vuelidate/core";
import { StatusesEnum } from "@/store";
import { required } from "@vuelidate/validators";
import { useStore } from "vuex";
import { DocumentTemplateActions } from "@/store/modules/documentTemplate/actions";
import { DocumentTemplateGetters } from "@/store/modules/documentTemplate/getters";
import { CompanyActions } from "@/store/modules/company/actions";
import { CompanyGetters } from "@/store/modules/company/getters";
import { useToast } from "vue-toastification";
import EntityScopeFields from "@/components/common/EntityScopeFields.vue";
import {
  defaultScopeFields,
  withScopeFields,
  scopeFromEntity,
} from "@/utils/entityScope";
import { fullTinyMceConfig, tinyMceScriptSrc } from "@/utils/tinymceConfig";
import { IScopeFields } from "@/types/common/entityApproval/EntityScope";
import { t } from "@/i18n";
import ManualField, {
  ManualFieldType,
} from "@/types/documents/documentTemplate/ManualField";
import { getCommonStatusOptions } from "@/utils/labels";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const toast = useToast();
const route = useRoute();
const store = useStore();
const statuses = computed(() => getCommonStatusOptions());
const scopeFields = ref<IScopeFields>(defaultScopeFields());
const directorates = ref<Array<{ id: string; name: string }>>([]);

const state = reactive<DocumentTemplate>({
  status: StatusesEnum.ACTIVE,
  name: "",
  template: "",
  footerEnabled: false,
  footerScope: "LAST_PAGE",
  footerHtml: "",
  footerHeightMm: 25,
  comment: "",
  manualFields: [],
});
const rules = {
  status: { required },
  name: { required },
  template: {},
  comment: {},
};
const $externalResults = ref({});
const submitted = ref(false);
const v$ = useVuelidate(rules, state, { $externalResults });
const manualFieldTypes: ManualFieldType[] = [
  "TEXTAREA",
  "DATE",
  "DATETIME",
  "SELECT",
  "MULTI_SELECT",
];

const manualFieldTypeLabels: Record<ManualFieldType, string> = {
  TEXTAREA: t("docTemplate.manualFieldType.textarea"),
  DATE: t("docTemplate.manualFieldType.date"),
  DATETIME: t("docTemplate.manualFieldType.datetime"),
  SELECT: t("docTemplate.manualFieldType.select"),
  MULTI_SELECT: t("docTemplate.manualFieldType.multiSelect"),
};

const addManualField = () => {
  state.manualFields = state.manualFields ?? [];
  state.manualFields.push({
    name: "",
    tag: "",
    type: "TEXTAREA",
    required: false,
    delimiter: ", ",
    outputFormat: "dd.MM.yyyy",
    sortOrder: state.manualFields.length + 1,
    options: [],
  });
};

const removeManualField = (index: number) => {
  state.manualFields?.splice(index, 1);
};

const addManualFieldOption = (field: ManualField) => {
  field.options = field.options ?? [];
  field.options.push({
    label: "",
    value: "",
  });
};

const removeManualFieldOption = (field: ManualField, optionIndex: number) => {
  field.options?.splice(optionIndex, 1);
};

const normalizeOptions = (field: ManualField) => {
  return (field.options ?? [])
    .map((option) => ({
      label: option.label?.trim(),
      value: option.value?.trim() || option.label?.trim(),
    }))
    .filter((option) => option.label && option.value);
};

const normalizeManualFields = () => {
  return (state.manualFields ?? [])
    .filter((field) => field.name?.trim() && field.tag?.trim())
    .map((field, index) => ({
      name: field.name.trim(),
      tag: field.tag.trim(),
      type: field.type || "TEXTAREA",
      required: field.required === true,
      delimiter: field.type === "MULTI_SELECT" ? field.delimiter || ", " : null,
      outputFormat:
        field.type === "DATE" || field.type === "DATETIME"
          ? field.outputFormat || "dd.MM.yyyy"
          : null,
      sortOrder: index + 1,
      options:
        field.type === "SELECT" || field.type === "MULTI_SELECT"
          ? normalizeOptions(field)
          : [],
    }));
};
async function handleSubmit(isFormValid: boolean) {
  submitted.value = true;
  const footerInvalid =
    state.footerEnabled &&
    (!state.footerHtml.trim() ||
      state.footerHeightMm < 10 ||
      state.footerHeightMm > 80);
  if (!isFormValid || footerInvalid) {
    return;
  }

  route.name === "DocumentTemplateEdit"
    ? await updateTemplate()
    : await createTemplate();
}

const createTemplate = async () => {
  const payload = withScopeFields(
    { ...state, manualFields: normalizeManualFields() },
    scopeFields.value
  );
  await store
    .dispatch(DocumentTemplateActions.CREATE, payload)
    .then(async () => {
      toast.success(t("approval.submitted"));
      await router.push({ name: "DocumentTemplateList" });
    })
    .catch(() => toast.error(t("approval.submitError")));
};

const updateTemplate = async () => {
  const payload = withScopeFields(
    { ...state, manualFields: normalizeManualFields() },
    scopeFields.value
  );
  await store
    .dispatch(DocumentTemplateActions.UPDATE, {
      id: route.params.id,
      data: payload,
    })
    .then(async () => {
      toast.success(t("approval.submitted"));
      await router.push({ name: "DocumentTemplateList" });
    })
    .catch(() => toast.error(t("approval.submitError")));
};

onMounted(async () => {
  await store.dispatch(CompanyActions.FETCH_ALL);
  directorates.value = store.getters[CompanyGetters.GET_ALL] ?? [];

  if (route.name === "DocumentTemplateEdit") {
    await store.dispatch(DocumentTemplateActions.FETCH_ONE, route.params.id);
    const documentTemplate = store.getters[DocumentTemplateGetters.GET_CURRENT];
    state.id = documentTemplate.id;
    state.name = documentTemplate.name;
    state.template = documentTemplate.template;
    state.footerEnabled = documentTemplate.footerEnabled ?? false;
    state.footerScope = documentTemplate.footerScope ?? "LAST_PAGE";
    state.footerHtml = documentTemplate.footerHtml ?? "";
    state.footerHeightMm = documentTemplate.footerHeightMm ?? 25;
    state.status = documentTemplate.status;
    state.comment = documentTemplate.comment;
    state.manualFields = (documentTemplate.manualFields ?? []).map(
      (field: ManualField) => ({
        ...field,
        required: field.required === true,
        delimiter: field.delimiter || ", ",
        outputFormat: field.outputFormat || "dd.MM.yyyy",
        options: field.options ?? [],
      })
    );
    scopeFields.value = scopeFromEntity(documentTemplate);
  }
});

return (_ctx: any,_cache: any) => {
  const _directive_auto_resize = _resolveDirective("auto-resize")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'DocumentTemplateList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(route).name === "DocumentTemplateEdit"
          ? _ctx.$t("docTemplate.titleEdit")
          : _ctx.$t("docTemplate.titleCreate")), 1),
      _createElementVNode("form", {
        onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", {
                for: "document-template-name",
                class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).name.$invalid && submitted.value }])
              }, _toDisplayString(_ctx.$t("docTemplate.name")), 3),
              _withDirectives(_createElementVNode("input", {
                id: "document-template-name",
                type: "text",
                class: _normalizeClass(["input-form", {
                'p-invalid': _unref(v$).name.$invalid && submitted.value,
              }]),
                placeholder: _ctx.$t('docTemplate.name'),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event))
              }, null, 10, _hoisted_6), [
                [_vModelText, _unref(v$).name.$model]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("docTemplate.comment")), 1),
              _withDirectives(_createElementVNode("textarea", {
                id: "document-template-comment",
                class: "w-full input-form",
                rows: "2",
                placeholder: _ctx.$t('docTemplate.comment'),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).comment.$model) = $event))
              }, null, 8, _hoisted_9), [
                [_directive_auto_resize],
                [_vModelText, _unref(v$).comment.$model]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("docTemplate.status")), 1),
                _createVNode(_unref(SegmentedButtons), {
                  class: "",
                  options: _unref(statuses),
                  required: "",
                  modelValue: _unref(v$).status.$model,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).status.$model) = $event))
                }, null, 8, ["options", "modelValue"])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("docTemplate.template")), 1),
              _createVNode(_unref(Editor), {
                class: "editor",
                disabled: false,
                id: "1",
                init: _unref(fullTinyMceConfig),
                "tinymce-script-src": _unref(tinyMceScriptSrc),
                "initial-value": "",
                inline: false,
                "model-events": "",
                "tag-name": "div",
                value: "",
                modelValue: _unref(v$).template.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).template.$model) = $event))
              }, null, 8, ["init", "tinymce-script-src", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  id: "document-template-footer-enabled",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).footerEnabled) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _unref(state).footerEnabled]
                ]),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)("docTemplate.footer.enabled")), 1)
              ]),
              (_unref(state).footerEnabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          value: "LAST_PAGE",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(state).footerScope) = $event))
                        }, null, 512), [
                          [_vModelRadio, _unref(state).footerScope]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("docTemplate.footer.lastPage")), 1)
                      ]),
                      _createElementVNode("label", _hoisted_20, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          value: "ALL_PAGES",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(state).footerScope) = $event))
                        }, null, 512), [
                          [_vModelRadio, _unref(state).footerScope]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("docTemplate.footer.allPages")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(t)("docTemplate.footer.height")), 1),
                      _withDirectives(_createElementVNode("input", {
                        id: "document-template-footer-height",
                        type: "number",
                        min: "10",
                        max: "80",
                        class: "input-form w-full",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).footerHeightMm) = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          _unref(state).footerHeightMm,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      (
                    submitted.value &&
                    (_unref(state).footerHeightMm < 10 || _unref(state).footerHeightMm > 80)
                  )
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_unref(t)("docTemplate.footer.heightError")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(t)("docTemplate.footer.html")), 1),
                      _createVNode(_unref(Editor), {
                        class: "editor",
                        disabled: false,
                        id: "document-template-footer-editor",
                        init: _unref(fullTinyMceConfig),
                        "tinymce-script-src": _unref(tinyMceScriptSrc),
                        "initial-value": "",
                        inline: false,
                        "model-events": "",
                        "tag-name": "div",
                        value: "",
                        modelValue: _unref(state).footerHtml,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(state).footerHtml) = $event))
                      }, null, 8, ["init", "tinymce-script-src", "modelValue"]),
                      (submitted.value && !_unref(state).footerHtml.trim())
                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_unref(t)("docTemplate.footer.htmlError")), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", _hoisted_28, _toDisplayString(_unref(t)("docTemplate.manualFields.title")), 1),
                  _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(t)("docTemplate.manualFields.subtitle")), 1)
                ]),
                _createVNode(_unref(Button), {
                  type: "button",
                  onClick: _withModifiers(addManualField, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("docTemplate.manualFields.addField")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).manualFields, (field, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "mt-4 rounded border border-gray-200 p-4"
                }, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_31, _toDisplayString(_unref(t)("docTemplate.manualFields.fieldName")), 1),
                      _withDirectives(_createElementVNode("textarea", {
                        class: "input-form w-full",
                        rows: "2",
                        "onUpdate:modelValue": ($event: any) => ((field.name) = $event)
                      }, null, 8, _hoisted_32), [
                        [_vModelText, field.name]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(t)("docTemplate.manualFields.tag")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "input-form w-full",
                        "onUpdate:modelValue": ($event: any) => ((field.tag) = $event)
                      }, null, 8, _hoisted_34), [
                        [_vModelText, field.tag]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_35, _toDisplayString(_unref(t)("docTemplate.manualFields.fieldType")), 1),
                      _withDirectives(_createElementVNode("select", {
                        class: "input-form w-full",
                        "onUpdate:modelValue": ($event: any) => ((field.type) = $event)
                      }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(manualFieldTypes, (type) => {
                          return _createElementVNode("option", {
                            key: type,
                            value: type
                          }, _toDisplayString(manualFieldTypeLabels[type]), 9, _hoisted_37)
                        }), 64))
                      ], 8, _hoisted_36), [
                        [_vModelSelect, field.type]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: `manual-field-required-${index}`,
                        "onUpdate:modelValue": ($event: any) => ((field.required) = $event)
                      }, null, 8, _hoisted_39), [
                        [_vModelCheckbox, field.required]
                      ]),
                      _createElementVNode("label", {
                        for: `manual-field-required-${index}`
                      }, _toDisplayString(_unref(t)("docTemplate.manualFields.required")), 9, _hoisted_40)
                    ]),
                    (field.type === 'MULTI_SELECT')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("label", _hoisted_42, _toDisplayString(_unref(t)("docTemplate.manualFields.delimiter")), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "input-form w-full",
                            "onUpdate:modelValue": ($event: any) => ((field.delimiter) = $event),
                            placeholder: ", "
                          }, null, 8, _hoisted_43), [
                            [_vModelText, field.delimiter]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (field.type === 'DATE' || field.type === 'DATETIME')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("label", _hoisted_45, _toDisplayString(_unref(t)("docTemplate.manualFields.outputFormat")), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "input-form w-full",
                            "onUpdate:modelValue": ($event: any) => ((field.outputFormat) = $event),
                            placeholder: "dd.MM.yyyy"
                          }, null, 8, _hoisted_46), [
                            [_vModelText, field.outputFormat]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (
                    field.type === 'SELECT' || field.type === 'MULTI_SELECT'
                  )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("label", _hoisted_49, _toDisplayString(_unref(t)("docTemplate.manualFields.options")), 1),
                            _createVNode(_unref(Button), {
                              type: "button",
                              onClick: _withModifiers(($event: any) => (addManualFieldOption(field)), ["prevent"])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)("docTemplate.manualFields.addOption")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option, optionIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: optionIndex,
                                class: "grid grid-cols-1 items-end gap-2 md:grid-cols-[1fr_1fr_auto]"
                              }, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("label", _hoisted_51, _toDisplayString(_unref(t)("docTemplate.manualFields.optionText")), 1),
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: "input-form w-full",
                                    rows: "2",
                                    "onUpdate:modelValue": ($event: any) => ((option.label) = $event)
                                  }, null, 8, _hoisted_52), [
                                    [_vModelText, option.label]
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("label", _hoisted_53, _toDisplayString(_unref(t)("docTemplate.manualFields.optionValue")), 1),
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: "input-form w-full",
                                    rows: "2",
                                    "onUpdate:modelValue": ($event: any) => ((option.value) = $event),
                                    placeholder: 
                            option.label ||
                            _unref(t)('docTemplate.manualFields.sameAsText')
                          
                                  }, null, 8, _hoisted_54), [
                                    [_vModelText, option.value]
                                  ])
                                ]),
                                _createVNode(_unref(Button), {
                                  type: "button",
                                  onClick: _withModifiers(($event: any) => (
                          removeManualFieldOption(field, optionIndex)
                        ), ["prevent"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)("docTemplate.manualFields.removeOption")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("p", _hoisted_55, _toDisplayString(_unref(t)("docTemplate.manualFields.optionHint")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_unref(Button), {
                      type: "button",
                      onClick: _withModifiers(($event: any) => (removeManualField(index)), ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("docTemplate.manualFields.removeField")), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]))
              }), 128))
            ]),
            _createVNode(EntityScopeFields, {
              modelValue: scopeFields.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((scopeFields).value = $event)),
              "directorate-options": directorates.value
            }, null, 8, ["modelValue", "directorate-options"]),
            _createElementVNode("div", null, [
              _createVNode(_unref(Button), { type: "submit" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$route.name === "DocumentTemplateEdit"
                  ? _ctx.$t("docTemplate.update")
                  : _ctx.$t("docTemplate.create")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ], 32)
    ])
  ], 64))
}
}

})